import { View } from '@/components'
import { createStyles } from '@codeleap/styles'
import { ViewProps } from '@codeleap/web'
import React from 'react'

type PageLayoutProps = {
  header?: React.ReactNode
  subHeader?: React.ReactNode
  children: React.ReactNode
} & ViewProps

export const PageLayout = (props: PageLayoutProps) => {
  const {
    header,
    subHeader,
    children,
    style,
    ...outerProps
  } = props

  return (
    <View style={[styles.outerWrapper, style]} {...outerProps}>
      {header}
      <View style={styles.innerWrapper}>
        {subHeader}

        {children}
      </View>
    </View>
  )
}

const styles = createStyles(theme => ({
  outerWrapper: {
    width: '100%',
    // maxWidth: 400,
    ...theme.presets.column,
    ...theme.presets.alignStart,
    ...theme.presets.justifyStart,
  },
  innerWrapper: {
    ...theme.presets.fullWidth,
    ...theme.presets.fullHeight,
    overflow: 'hidden',
    borderTopLeftRadius: theme.radius.custom,
    borderTopRightRadius: theme.radius.custom,
    ...theme.presets.column,
    backgroundColor: theme.colors.bgDefault,
    flex: 1,
  },
}))
